export function getFeatureFlags(hostname = '') {
  const isQa2orCert = hostname
    .toLowerCase()
    .includes('qa2');

  const isCert = hostname
    .toLowerCase()
    .includes('cert');

  return {
    isQa2orCert: isQa2orCert || isCert,
  };
}
export function getEnv(hostname = '') {
	const host = hostname.toLowerCase();
	if (host.includes('citi') && host.includes('test')) {
		return 'cert';
	}
	const preProd = ['qa','dev','cert','localhost','sit'];
	let currentEnv = preProd.filter(env => host.includes(env));
	return currentEnv.length ? currentEnv[0] : 'prod';
}
export default {
  getFeatureFlags,
  getEnv
};
